// Theme constants shared by the pre-paint script (imported by the root
// layout, a server component) and the client store in theme-mode.ts.

export type ThemeMode = "light" | "dark" | "system";

export const THEME_MODES: ThemeMode[] = ["light", "dark", "system"];
export const THEME_STORAGE_KEY = "theme";
/** what a viewer who never picked one gets: the look the app always had */
export const DEFAULT_THEME_MODE: ThemeMode = "light";
export const DARK_QUERY = "(prefers-color-scheme: dark)";
/** hides <body> (globals.css) until the dark tokens are on screen */
export const THEME_PENDING_ATTRIBUTE = "data-theme-pending";

/**
 * Inline <head> script, run before first paint.
 *
 * Every page is prerendered with the light theme's CSS. For a viewer whose
 * choice resolves to dark this marks <html> dark (a dark canvas via
 * color-scheme) and hides the page until AntdProvider has applied the dark
 * tokens, instead of flashing the light page; the timeout shows it anyway if
 * the bundle never gets that far.
 */
export const THEME_INIT_SCRIPT = `(function(){try{var d=document.documentElement,m=null;try{m=localStorage.getItem(${JSON.stringify(
	THEME_STORAGE_KEY,
)})}catch(e){}if(${JSON.stringify(THEME_MODES)}.indexOf(m)<0)m=${JSON.stringify(
	DEFAULT_THEME_MODE,
)};if(m==="dark"||(m==="system"&&window.matchMedia(${JSON.stringify(
	DARK_QUERY,
)}).matches)){d.setAttribute("data-theme","dark");d.setAttribute(${JSON.stringify(
	THEME_PENDING_ATTRIBUTE,
)},"");setTimeout(function(){d.removeAttribute(${JSON.stringify(
	THEME_PENDING_ATTRIBUTE,
)})},4000)}}catch(e){}})();`;
